import 'component/css/order.css';

import React, { useEffect, useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPlus,
  faTimes,
} from '@fortawesome/free-solid-svg-icons';

import API from 'service/api';
import Util, { Data } from 'service/util';

import moment from 'moment';
import Form from 'component/Form';
import PopMessage from 'component/pop-msg/PopMessage';

import Loading from 'component/Loading';
import DatePicker from 'react-datepicker';

import SearchableList from 'component/dropdown/SearchableList';

const defaultProduct = {
  id: null,
  grp_name: 'NA',
  srv_name: '(無)',
  srv_desc: ''
};

const AddOrderModal = ({order, ...props}) =>
{
  if (!Util.hasValue(props.owner.id)) throw `[${AddOrderModal.name}] must provide owner user ID`;

  const [items, setItems] = useState([
    { item_id: null, qty: 1, unit_price: 0, discount: 0, delivery_dtm: null},
    { item_id: null, qty: 1, unit_price: 0, discount: 0, delivery_dtm: null},
    { item_id: null, qty: 1, unit_price: 0, discount: 0, delivery_dtm: null},
    { item_id:    2, qty: 1, unit_price: 0, discount: 0, delivery_dtm: null},
  ]);

  const [company,      setCompany    ] = useState(Data.company[0].cd);
  const [cd_license,   setLicense    ] = useState(props.selectedVehicleLicense || props.owner.vehicles[0].cd_license || '');
  const [order_dtm,    setOrderDate  ] = useState(moment().startOf('day').toDate());
  const [payment_type, setPaymentType] = useState('0');
  const [payment_ref,  setPaymentRef ] = useState('');
  const [srv_addr,     setAddress    ] = useState(null);
  const [remarks,      setRemarks    ] = useState(null);

  const [products, setProducts]        = useState(false);

  const [ dictProd ] = useState( new Map() );

  useEffect(() => {
    API.getUnitServices().then(data => {
      data.reduce((r,p) => { r.set(p.id, p); return r; }, dictProd);
      setProducts(data);
    });
  }, []);

  const setItemProduct = (orderItem, product) =>
  {
    orderItem.item_id = product.id;
    orderItem.unit_price = product?.price||0;
    setItems(Array.from(items));
  }
  const setItemPrice = (orderItem, price) =>
  {
    orderItem.unit_price = price;
    setItems(Array.from(items));
  }
  const setItemQuantity = (orderItem, qty) =>
  {
    orderItem.qty = qty;
    setItems(Array.from(items));
  }
  const setItemDiscount = (orderItem, discount) =>
  {
    orderItem.discount = discount;
    setItems(Array.from(items));
  }
  const setItemDeliveryDate = (orderItem, delivery_dtm) =>
  {
    orderItem.delivery_dtm = delivery_dtm || null;
    setItems(Array.from(items));
  }

  const addRow = () => {
    setItems([...items, { item_id: null, qty: 1, unit_price: 0, discount: 0, delivery_dtm: null }]);
  }
  const removeRow = (i) => {
    items.splice(i, 1);
    setItems(Array.from(items));
  }

  const submit = (e) =>
  {
    e.preventDefault();
    e.stopPropagation();

    let _items = items.filter(itm => !!itm.item_id && !!itm.qty && !!(itm.unit_price||0 + itm.discount||0));
    if (!_items.length) {
      PopMessage.show('訂單必需有項目', '警告', 'danger');
      return false;
    }

    _items.forEach(x => new Date(x.delivery_dtm).setHours(8,0,0,0));

    let dto = {
       company, cd_license, order_dtm
      ,payment_type, payment_ref
      ,srv_addr: (srv_addr || null)
      ,remarks: (remarks || null)
      ,cust_id: props.owner.id
      ,items: _items
    };

    API.placeOrder(dto).then(resp => {
      if (!resp.success) {
        PopMessage.show(resp.msg, '無法新增訂單', 'danger');
      } else {
        PopMessage.show('成功新增訂單紀錄', '成功', 'success');
        props?.onAdded(resp.msg);
        props?.onClose();
      }
    });

    return false;
  }

  if (!products) return <Loading small={true} />;

  let totalPrice = items.reduce((r,x) => {
    return r + (!x.item_id ? 0 : x.qty*x.unit_price - x.discount);
  }, 0);

  return (<>
    <Form className="add-order" onSubmit={submit}>
      <div className="order-detail">
        <section>
          <h3>購買項目</h3>
          <table className="data-table full-width">
            <colgroup>
              <col width="36px"  id="col-order-item-btn" />
              <col width="300px" id="col-order-item-id" />
              <col width="100px" id="col-order-item-delivery-date" />
              <col width="100px" id="col-order-item-price" />
              <col width="100px" id="col-order-item-qty" />
              <col width="100px" id="col-order-item-discount" />
              <col width="100px" id="col-order-item-total" />
            </colgroup>
            <thead>
              <tr>
                <th className="col-order-item-btn"></th>
                <th className="col-order-item-id">產品/服務</th>
                <th className="col-order-item-delivery-date">送遞日期</th>
                <th className="col-order-item-price">單價</th>
                <th className="col-order-item-qty">數量</th>
                <th className="col-order-item-discount">折扣</th>
                <th className="col-order-item-total">總數</th>
              </tr>
            </thead>
            <tbody>
              { items.map((x,i) =>
                <tr key={i}>
                  <td className="col-order-item-btn">
                    { i==0
                      ?<button type="button" className="btn green" onClick={addRow}>
                        <FontAwesomeIcon icon={faPlus} />
                      </button>
                      :<button type="button" className="btn red" onClick={e=>removeRow(i)}>
                        <FontAwesomeIcon icon={faTimes} />
                      </button>
                    }
                  </td>
                  <td className="col-order-item-id">
                    <SearchableList value={dictProd.get(x.item_id)} onChange={p=>setItemProduct(x, p)}
                      items={products} withDefault={defaultProduct}
                      filter={(p,v) => -1<`#${p.id}||${p.grp_name}||${p.srv_name}||${p.srv_desc}`.toUpperCase().indexOf(v.toUpperCase())}
                      getTitle={p => p.grp_name}
                      getDesc={p => p.srv_name}
                    />
                  </td>
                  <td className="col-order-item-delivery-date">
                    <DatePicker selected={x.delivery_dtm} onChange={d=>setItemDeliveryDate(x,d)}
                      dateFormat="yyyy-MM-dd" required={x.unit_price!=0}/>
                  </td>
                  <td className="col-order-item-price">
                    <input type="number" value={x.unit_price} min="0" step="0.01"
                      onChange={e=>setItemPrice(x, parseFloat(e.target.value))} />
                  </td>
                  <td className="col-order-item-qty">
                    <input type="number" value={x.qty} min="0"
                      onChange={e=>setItemQuantity(x, parseFloat(e.target.value))} />
                  </td>
                  <td className="col-order-item-discount">
                    <input type="number" value={x.discount} min="0" step="0.01"
                      onChange={e=>setItemDiscount(x, parseFloat(e.target.value))} />
                  </td>
                  <td className="col-order-item-total">
                    ${ Util.nf2( x.qty * x.unit_price - x.discount ) }
                  </td>
                </tr>
              )}
            </tbody>
            <tfoot>
              <tr>
                <td className="col-order-item-btn"></td>
                <td className="col-order-item-delivery-date"></td>
                <td className="col-order-item-item"></td>
                <td className="col-order-item-price"></td>
                <td className="col-order-item-qty"></td>
                <td className="col-order-item-discount"></td>
                <td className="col-order-item-total">
                  <strong>${ Util.nf2( totalPrice ) }</strong>
                </td>
              </tr>
            </tfoot>
          </table>
        </section>
        <section>
          <h3>訂單資料</h3>
          <div className="row">
            <label className="field">
              <strong>公司</strong>
              <select value={company} onChange={e=>setCompany(e.target.value)}>
                { Data.company.map(com =>
                  <option key={com.cd} value={com.cd}>{com.cd} - {com.name}</option>
                )}
              </select>
            </label>
            <label className="field">
              <strong>車牌</strong>
              <SearchableList value={cd_license} onChange={license =>setLicense(license)}
                items={props.owner.vehicles.map(v => v.cd_license)}
                format={v => v}
                filter={(c,v) => -1<c.toUpperCase().indexOf(v.toUpperCase())}
              />
            </label>
            <label className="field">
              <strong>下單日期</strong>
              <DatePicker required={true}
                selected={order_dtm} dateFormat="yyyy-MM-dd"
                onChange={ d=>setOrderDate(d) }
              />
            </label>
          </div>
          <div className="row">
            <label className="field">
              <strong>付款類型</strong>
              <select value={payment_type} onChange={e=>setPaymentType(e.target.value)}>
                <option value="0">0 - 未付款</option>
                <option value="C">C - 現金</option>
                <option value="T">T - 轉賬</option>
                <option value="Q">Q - 支票</option>
              </select>
            </label>
            <label className="field">
              <strong>參考</strong>
              <input value={payment_ref} onChange={e=>setPaymentRef(e.target.value)}
                placeholder="如支票號碼"/>
            </label>
          </div>
          <label className="field">
            <strong>地址</strong>
            <input value={srv_addr} onChange={e=>setAddress(e.target.value)} onBlur={e=>setAddress(e.target.value.trim()||null)}/>
          </label>
          <label className="field">
            <strong>備註</strong>
            <textarea value={remarks} rows="3"
              onChange={e=>setRemarks(e.target.value.trim()||null)}>
            </textarea>
          </label>
        </section>
      </div>
      <div className="action-panel">
        <span className="dummy"></span>
        <button className="btn blue">確定</button>
      </div>
    </Form>
  </>);
}

export default AddOrderModal;